import React from "react";

export interface RequiredAsteriskProps {
  style?: React.CSSProperties;
}

const defaultStyle: React.CSSProperties = {
  color: "#b00020",
  fontWeight: 700,
  marginLeft: 4,
};

export const RequiredAsterisk: React.FC<RequiredAsteriskProps> = ({ style }) => (
  <span aria-hidden="true" style={{ ...defaultStyle, ...style }}>*</span>
);

export default RequiredAsterisk;
